import React, { useState } from 'react'
import "./Clients.scss"
import { TiGroupOutline } from "react-icons/ti";
import { RiDeleteBinLine, RiGroupLine } from "react-icons/ri";
import { Link } from 'react-router-dom';
import { IoIosArrowDown, IoMdCopy } from 'react-icons/io';
import { FaRegEdit } from "react-icons/fa";
import { MdLockOutline } from "react-icons/md";
import { PiUpload } from 'react-icons/pi';


export default function Clients() {
      const [open, setOpen] = useState(null);
      const orders = [
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "New"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "Inactive"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "Blocked"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "Active"
    },
    {
      id: "#301555",
      client: "Osama alabyare",
      product: "Social media",
      date: "12/12/23",
      time: "12:00 PM",
      amount: "EGP 241.00",
      status: "On Process"
    }
  ];

  return (
    <div className='p-3'>
          
        <div className=' d-flex align-items-center mb-2  justify-content-between'>
            <div className='All-clients'>
                <div className=' d-flex align-items-center justify-content-between'>
  <span className='icon-clients  mb-3'>
                    <TiGroupOutline />

                </span> 
                  <span className="product-headerr" onClick={() => setOpen(open === "Time" ? null : "Time")}>
                      This week
                      <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {open === "Time" && (
                        <div className="list-body">
                          <ul className="list">
                            <li>All Time</li>
                            <li>24 Hours</li>
                            <li>30 Days</li>
                            <li>3 Months</li>
                            <li>6 Months</li>
                            
                          </ul>
                        </div>
                      )}
                    </span>
                </div>
              
                <div className=' d-flex gap-5'>
    <div>
                    <p style={{
                        fontSize:"13px",
                        color:"#8b8d97",
                        marginBottom:"5px",
                       
                    }}>All Clients</p>
                    <div className=' d-flex gap-2'>
<span style={{
    fontWeight:"bold"
}}>102,202</span>
                    <span style={{
                        color:"#519c66"
                    }}>+15.80%</span>
                    </div>
                    
                </div>

                  <div>
                    <p   style={{
                        fontSize:"13px",
                        color:"#8b8d97",
                        marginBottom:"5px",
                       
                    }}>Active</p>
                    <div className=' d-flex gap-2'>
<span style={{
    fontWeight:"bold"
}}>102,202</span>
                    <span style={{
                        color:"#519c66"
                    }}>+15.80%</span>
                    </div>
                    
                </div>

                  <div>
                    <p  style={{
                        fontSize:"13px",
                        color:"#8b8d97",
                        marginBottom:"5px",
                       
                    }}>In-Active</p>
                    <div className=' d-flex gap-2'>
<span style={{
    fontWeight:"bold"
}}>102,202</span>
                    <span style={{
                        color:"#519c66"
                    }}>+15.80%</span>
                    </div>
                    
                </div>
                </div>
            
            </div>

             <div className='New-clients'>
                <div className=' d-flex align-items-center justify-content-between'>
  <span className='icon-clients  mb-3' >
                    <RiGroupLine />

                </span> 
                  <span className="product-headerr" onClick={() => setOpen(open === "Time" ? null : "Time")}>
                      This week
                      <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {open === "Time" && (
                        <div className="list-body">
                          <ul className="list">
                            <li>All Time</li>
                            <li>24 Hours</li>
                            <li>30 Days</li>
                            <li>3 Months</li>
                            <li>6 Months</li>
                            
                          </ul>
                        </div>
                      )}
                    </span>
                </div>
              
                <div className=' d-flex gap-5'>
    <div>
                    <p style={{
                        fontSize:"13px",
                        color:"#8b8d97",
                        marginBottom:"5px",
                       
                    }}>All Clients</p>
                    <div className=' d-flex gap-2'>
<span style={{
    fontWeight:"bold"
}}>102,202</span>
                    <span style={{
                        color:"#519c66"
                    }}>+15.80%</span>
                    </div>
                    
                </div>

                  <div>
                    <p   style={{
                        fontSize:"13px",
                        color:"#8b8d97",
                        marginBottom:"5px",
                       
                    }}>Active</p>
                    <div className=' d-flex gap-2'>
<span style={{
    fontWeight:"bold"
}}>102,202</span>
                    <span style={{
                        color:"#519c66"
                    }}>+15.80%</span>
                    </div>
                    
                </div>

                  <div>
                    <p  style={{
                        fontSize:"13px",
                        color:"#8b8d97",
                        marginBottom:"5px",
                       
                    }}>In-Active</p>
                    <div className=' d-flex gap-2'>
<span style={{
    fontWeight:"bold"
}}>102,202</span>
                    <span style={{
                        color:"#519c66"
                    }}>+15.80%</span>
                    </div>
                    
                </div>
                </div>
            
            </div>
        </div>

          <div className="headerrr">
  <div className="stock-filters">
    <button className="stock-filter actives">24 Hour</button>
    <button className="stock-filter">7 Days</button>
    <button className="stock-filter">30 Days</button>
    <button className="stock-filter">12 Months</button>
  </div>

  <div className="search-wrapper">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>

  <div className="stock-header">
    <input type="date" placeholder="select dates" />
    <div className="stock-actions">
      <button className="stock-btn blue">Filters</button>
      <button className="stock-btn">Export</button>
    </div>
  </div>
</div>
       <div className="orders-section">
          <div className="orders-table">
            <div className="full-width-table">
              <table>
                <thead >
                  <tr>
                   
                    <th>Client Name</th>
                    <th>Phone Number</th>
                       <th>Created</th>
                    <th className="product-header" onClick={() => setOpen(open === "Product" ? null : "Product")}>
                      Country
                      <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {open === "Product" && (
                        <div className="list-body">
                          <ul className="list">
                            <li>All Products</li>
                            <li>Social media</li>
                            <li>E-marketing</li>
                          </ul>
                        </div>
                      )}
                    </th>
                  
                    <th>Amount</th>
               
                       <th className="product-header" onClick={() => setOpen(open === "Status" ? null : "Status")}>
                      Status
                      <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {open === "Status" && (
                        <div className="list-body">
                          <ul className="list">
                            <li>All Products</li>
                            <li>Social media</li>
                            <li>E-marketing</li>
                          </ul>
                        </div>
                      )}
                    </th>
                     <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order, idx) => (
                    <tr key={idx}>
                      <td className="color-gr">{order.client}
                        <div>
    <div className=' d-flex align-items-center gap-2'>
   <div style={{
                            backgroundColor:"#0ec755",
                            width:"10px",
                            height:"10px",
                            borderRadius:"50px"

                        }}></div>
                         <span style={{
                            color:"#b6bfe8"
                        }}>
                            Online</span>
                        </div>
                     
                        <span style={{
                            color:"#8b909a"
                        }}>Rawan@gmail.com</span>
                        </div>
                    
                      </td>
                      <td className="color-gr">{order.client}</td>
                      <td>{order.product}</td>
                
                      <td>{order.amount}</td>
                      <td>{order.amount}</td>
                      <td>
                        <span className={`statuss ${order.status.toLowerCase().replace(/\s+/g, '')}`}>
                          {order.status}
                        </span>
                      </td>
                      <td className=' ' >
                <Link to="/dashboard/Informations" className='no-style-link'>  <FaRegEdit className='action-icon' /></Link>     
                          
                            <MdLockOutline className='action-icon' />
                            <RiDeleteBinLine className='action-icon' />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="table-footer">
                <div className="showing-info">
                  Showing 17 of 100
                </div>
                <div className="pagination">
                  <button className="active">1</button>
                  <button>2</button>
                  <button>3</button>
                  <button>4</button>
                  <button>5</button>
                  <button>Next</button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}
